//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { CustomFieldValueInputItem } from './CustomFieldValueInputItem';
import { CustomFieldType } from './Enums';

export class CustomFieldEmailValueInputItem extends CustomFieldValueInputItem {
    Email: string | null = null;
    override readonly FieldType: CustomFieldType = CustomFieldType.Email;

    constructor(initializer?: Partial<Omit<CustomFieldEmailValueInputItem, "FieldType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CustomFieldEmailValueInputItem";
}
